export default {
    "report.report.463915-0": "Return",
    "report.report.463915-1": "Abnormal statistics",
    "report.report.463915-2": "Energy consumption statistics",
    "report.report.463915-3": "Electricity data",
    "report.report.463915-4": "Equipment electricity bill",
    "report.report.463915-5": "Operation log",
    "report.report.463915-6": "Loading...",
    "abnormal.abnormal.628134-0": "User list",
    "abnormal.abnormal.628134-1": "Search",
    "abnormal.abnormal.628134-2": "Please enter the user name",
    "abnormal.abnormal.628134-3": "No device at the moment",
    "abnormal.abnormal.628134-4": "Please select the cycle",
    "abnormal.abnormal.628134-5": "Day",
    "abnormal.abnormal.628134-6": "Month",
    "abnormal.abnormal.628134-7": "Season",
    "abnormal.abnormal.628134-8": "Year",
    "abnormal.abnormal.628134-9": "Customization",
    "abnormal.abnormal.628134-10": "Please select the time",
    "abnormal.abnormal.628134-11": "Query",
    "abnormal.abnormal.628134-12": "Export",
    "abnormal.abnormal.628134-13": "Abnormal proportion",
    "abnormal.abnormal.628134-14": "Abnormal statistics",
    "abnormal.abnormal.628134-15": "Abnormal cause",
    "abnormal.abnormal.628134-16": "Abnormal (second)",
    "abnormal.abnormal.628134-17": "Abnormal list",
    "abnormal.abnormal.628134-18": "Device name",
    "abnormal.abnormal.628134-19": "Device number",
    "abnormal.abnormal.628134-20": "Exception Name",
    "abnormal.abnormal.628134-21": "abnormal time",
    "abnormal.abnormal.628134-22": "re is no exception message yet",
    "abnormal.abnormal.628134-23": "Please select the date",
    "abnormal.abnormal.628134-24": "Unusual proportion",
    "abnormal.abnormal.628134-25": "Total",
    "abnormal.abnormal.628134-26": "Number of abnormalities in the current period",
    "abnormal.abnormal.628134-27": "Number of anomalies in the previous period",
    "operation_log.operation.506627-0": "Please select the time",
    "operation_log.operation.506627-1": "Login to account",
    "operation_log.operation.506627-2": "Device number",
    "operation_log.operation.506627-3": "Device name",
    "operation_log.operation.506627-4": "Enquiry",
    "operation_log.operation.506627-5": "Export",
    "operation_log.operation.506627-6": "User Nickname",
    "operation_log.operation.506627-7": "operation content",
    "operation_log.operation.506627-8": "Successful",
    "operation_log.operation.506627-9": "operation time",
    "operation_log.operation.506627-10": "No data at present ",
    "energy.energy.528939-0": "User List ",
    "energy.energy.528939-1": "Search ",
    "energy.energy.528939-2": "Please enter user name ",
    "energy.energy.528939-3": "No equipment available ",
    "energy.energy.528939-4": "Day ",
    "energy.energy.528939-5": "Month ",
    "energy.energy.528939-6": "Year ",
    "energy.energy.528939-7": "Please select a date ",
    "energy.energy.528939-8": "Inquiry ",
    "energy.energy.528939-9": "Export ",
    "energy.energy.528939-10": "Energy Consumption Comparison ",
    "energy.energy.528939-11": "Electricity Today (kw·h) ",
    "energy.energy.528939-12": "Same period yesterday (kw·h) ",
    "energy.energy.528939-13": "Electricity Usage Trends ",
    "energy.energy.528939-14": "Electricity consumption for this month (kw·h) ",
    "energy.energy.528939-15": "Same period last month (kw·h) ",
    "energy.energy.528939-16": "Electricity consumption (kw·h) this year ",
    "energy.energy.528939-17": "Same period last year (kw·h) ",
    "energy.energy.528939-18": "Time-sharing Statistics of Energy Consumption ",
    "energy.energy.528939-19": "Energy consumption year-on-year ",
    "energy.energy.528939-20": "Energy Consumption Ranking ",
    "energy.energy.528939-21": "Equipment Name ",
    "energy.energy.528939-22": "Equipment Number ",
    "energy.energy.528939-23": "Energy Consumption ",
    "energy.energy.528939-24": "Voltage ",
    "energy.energy.528939-25": "This month ",
    "energy.energy.528939-26": "This quarter ",
    "energy.energy.528939-27": "This year ",
    "energy.energy.528939-28": "Total Amount ",
    "energy.energy.528939-29": "Previous period Energy Consumption ",
    "energy.energy.528939-30": "Current Energy Consumption ",
    "electricity.electricity.543197-0": "Please select the time",
    "electricity.electricity.543197-1": "Device Id",
    "electricity.electricity.543197-2": "Device Name",
    "electricity.electricity.543197-3": "Query",
    "electricity.electricity.543197-4": "Export",
    "electricity.electricity.543197-5": "Electricity",
    "electricity.electricity.543197-6": "Operation",
    "electricity.electricity.543197-7": "View",
    "electricity.electricity.543197-8": "No electricity data",
    "electricity.electricity.543197-9": "Time",
    "electricity.electricity.543197-10": "Power",
    "deviceMoney.deviceMoney.560758-0": "Top-up subsidiary equipment",
    "deviceMoney.deviceMoney.560758-1": "Equipment electricity subsidiary",
    "deviceMoney.deviceMoney.560758-2": "Please select the time",
    "deviceMoney.deviceMoney.560758-3": "User Accounts",
    "deviceMoney.deviceMoney.560758-4": "Phone Number",
    "deviceMoney.deviceMoney.560758-5": "Device Id",
    "deviceMoney.deviceMoney.560758-6": "Device Name",
    "deviceMoney.deviceMoney.560758-7": "Query",
    "deviceMoney.deviceMoney.560758-8": "Export",
    "deviceMoney.deviceMoney.560758-9": "User nickname",
    "deviceMoney.deviceMoney.560758-10": "Transaction",
    "deviceMoney.deviceMoney.560758-11": "Balance of the original equipment",
    "deviceMoney.deviceMoney.560758-12": "Now the equipment balance",
    "deviceMoney.deviceMoney.560758-13": "Order number",
    "deviceMoney.deviceMoney.560758-14": "Time",
    "deviceMoney.deviceMoney.560758-15": "Temporarily no data",
    "deviceMoney.deviceMoney.560758-16": "Current price",
    "deviceMoney.deviceMoney.560758-17": "The day power consumption",
    "deviceMoney.deviceMoney.560758-18": "On the same day with electricity",
    "deviceMoney.deviceMoney.560758-19": "Line electric loss",
    "deviceMoney.deviceMoney.560758-20": "Equally Shared power",
    "deviceMoney.deviceMoney.560758-21": "Update time",

    //报警表单
    "alert.index.303927-0": "Alarm status:",
    "alert.index.303927-1": "Please select Alarm Status",
    "alert.index.303927-2": "Not processed",
    "alert.index.303927-3": "Processed",
    "alert.index.303927-4": "False positives",
    "alert.index.303927-5": "Start and end time:",
    "alert.index.303927-6": "Please select a start and end time",
    "alert.index.303927-7": "Search",
    "alert.index.303927-8": "All regions",
    "alert.index.303927-9": "prompt",
    "alert.index.303927-10": "Whether to the device",
    "alert.index.303927-11": "dispose",
    "alert.index.303927-12": "operate"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/En/report-en.js